module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "normalBar"
    }
  }, [_c('mt-header', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "title": _vm.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    },
    slot: "left"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "slot": "icon",
      "src": require("../../../assets/icon/back.png"),
      "height": "auto",
      "width": "8px"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "background-color": "#d8d8d8"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71891b0d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/navbar/normalBar.vue
// module id = 578
// module chunks = 1